export enum MerchantStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface IMerchant {
  _id?: string
  objectId?: string
  prefix: string
  username: string
  name: string
  taxId: string
  taxIdentificationNumber?: string
  phoneNumber?: string
  address: string
  subdistrict: string
  district: string
  province: string
  config: IMerchantConfig
  status: MerchantStatus
  zipcode: string
  actor: string
  facebookAccessToken?: string
  expiresDate: string
  createdAt: string
  updatedAt: string
  tiktok?: IMerchantTiktok
}

// GET /merchant/options — ตัวเลือกร้านให้ super admin เลือกตอนล็อกอิน
export interface IMerchantOption {
  prefix: string
  name: string
  status?: MerchantStatus
  expiresDate?: string
  isExpired?: boolean
}

export interface IMerchantConfig {
  maximum?: IMerchantConfigMaximum
  display?: IMerchantConfigDisplay
  providers?: IMerchantConfigProviders
  platformsAccounts?: {
    [key: string]: number
  }
  openCRM?: boolean
  openChat?: boolean
  openTiktok?: boolean
  openShopee?: boolean
  lineToken?: string
  comission?: number
  taxPercent?: number
  codPercent?: number
  commissionPercent?: number
  commissionOrder?: number
  commission?: number
  returnPercent?: number
  shippingCostFix?: number
  bank?: IMerchantConfigBank
  dulplicateOrderDate?: number
}

export interface IMerchantConfigBank {
  name?: string
  account?: string
  number?: string
  code?: string
}

export interface IMerchantConfigDisplay {
  sales?: boolean
  cost?: boolean
  profit?: boolean
  order?: boolean
  unit?: boolean
  comission?: boolean
  return?: boolean
  crm?: boolean
  ownerOrder?: boolean
  totalOrder?: boolean
  upsaleTotal?: boolean
  upsalePriceTotal?: boolean
  telesaleTotal?: boolean
  social?: boolean
  productPopular?: boolean
}

export interface IMerchantConfigMaximum {
  order: number
  orderPerDay: number
  employee: number
  category: number
  product: number
  lead: number
}

export interface IMerchantConfigProviders {
  flash?: IMerchantConfigProviderFlash
  jnt?: IMerchantConfigProviderJnt
  kerry?: IMerchantConfigProviderKerry
  thaiPost?: IMerchantConfigProviderThaiPost
  bestExpress?: IMerchantConfigProviderBestExpress
  spx: IMerchantConfigProvidersSPX
}

export interface IMerchantConfigProviderFlash {
  enabled: boolean
  username: string
  password: string
  merchantId: string
  merchantParentId: string
  merchantParentKey: string
}

export interface IMerchantConfigProviderJnt {
  enabled: boolean
  shopId: string
  shopName: string
}

export interface IMerchantConfigProviderKerry {
  enabled: boolean
  merchantId: string
  kerryId: string
  kerryKey: string
}

export interface IMerchantConfigProviderThaiPost {
  enabled: boolean
}

export interface IMerchantConfigProviderBestExpress {
  enabled: boolean
}

export interface IMerchantConfigProvidersSPX {
  appId: string
  appSecret: string
  userId: string
  userSecret: string
  enabled: boolean
}

export interface IMerchantTiktok {
  accessToken: string
  accessTokenExpireIn: number
  refreshToken: string
  refreshTokenExpireIn: number
  openId: string
  sellerName: string
  sellerBaseRegion: string
  userType: number
}
